<section class="form_section">
    <h2>Etiquetas</h2>

    <form class="form_register_minutes">
        <mat-form-field class="example-chip-list">
          <mat-label>Etiquetas del Trato</mat-label>
          <mat-chip-grid #chipGrid aria-label="Selecciona etiquetas">
            <mat-chip-row *ngFor="let tag of tagsDeal" (removed)="remove(tag)">
              {{ tag }}
              <button matChipRemove [attr.aria-label]="'remove ' + tag">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
      
          <input
            name="currentTag"
            placeholder="Nueva Etiqueta..."
            #tagInput
            [(ngModel)]="currentTag"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"
          />

          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            <mat-option *ngFor="let tag of filteredTags()" [value]="tag">{{ tag }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <button mat-button (click)="updateTagsDeal()">Guardar</button>
    </form>
         
</section>